import { useState } from 'react';
import './App.css';

function App() {

  const [temp, setTemp] = useState(0);
  
  const handleClick = (e)=> {
    if(e.target.innerText === '+') {
      setTemp(temp + 1);
    } else {
      setTemp(temp - 1);
    }
  }

  return (
    <div className="container">
      <h1>Temp Convertor</h1>

      <div className="card">

        <div className={`card-circle ${temp >= 1 ? 'red' : 'blue'}`}>
         <span className="temp">{temp}°C</span>
        </div>
        <div className="buttons">
          <button onClick={handleClick}><span className='big'>-</span></button>
          <button onClick={handleClick}><span className='big'>+</span></button>
        </div>

      </div>

    </div>
  );
}

export default App;
